'use strict'

export function matchLocations (supTask, requestLocation) {
  let valid = true
  let equal = false
  let approximate = false
  if (requestLocation && requestLocation.lon != null && requestLocation.lat != null && supTask && supTask.lon != null && supTask.lat != null) {
    equal = isEqualCoords(supTask.lon, requestLocation.lon, 6) && isEqualCoords(supTask.lat, requestLocation.lat, 6)
    if (!equal) {
      equal = isEqualCoords(supTask.lon, requestLocation.lon, 5) && isEqualCoords(supTask.lat, requestLocation.lat, 5)
      approximate = equal
    }
    valid = equal
  }
  return { valid, equal, approximate }
}

function isEqualCoords (val1, val2, digits) {
  if (val1 === val2) {
    return true
  }
  if (val1 != null && val2 != null) {
    val1 = val1.toFixed(digits)
    val2 = val2.toFixed(digits)
    return val1 === val2
  }
  return false
}
